// vendors
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import PropTypes from 'prop-types';
import Parallax from '../../components/Parallax/Parallax';
import InView from '../../components/InView/InVew';

const L1 = 0.043014853;
const L2 = 0.063164248;
const L3 = 0.0927522;

function RestaurantPageAbout({ teamContent, viewContent }) {
  const [isMobile, setIsMobile] = React.useState(true);

  React.useEffect(() => {
    const handleResize = () => {
      const value = window.matchMedia('(max-width: 1024px)').matches;

      if (value !== isMobile) setIsMobile(value);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="grid grid-cols-2 gap-5 lg:grid-cols-6">
      <InView className="col-span-2 row-start-1 self-center text-center lg:col-start-5 lg:text-left">
        {teamContent}
      </InView>

      <Parallax
        className="col-span-1 row-start-2 lg:col-span-3 lg:row-start-1"
        disable={isMobile}
        delta={L1}
      >
        <StaticImage
          src="../../images/restaurant/April-Bistro-02.jpg"
          width={832}
          sizes="(max-width: 1920px) 44vw, 832px"
          alt={``}
        />
      </Parallax>

      <Parallax
        delta={L3}
        disable={isMobile}
        className="relative col-span-1 col-start-2 row-start-2 self-start lg:-top-1/2 lg:col-span-2 lg:col-start-5"
      >
        <StaticImage
          src="../../images/restaurant/April-Bistro-03.jpg"
          width={542}
          sizes="(max-width: 1024px) 44vw, (max-width: 1920px) 30vw, 542px"
          alt={``}
        />
      </Parallax>

      <InView className="col-span-2 row-start-3 self-center text-center lg:text-left">
        {viewContent}
      </InView>

      <Parallax
        delta={L1}
        disable={isMobile}
        className="col-span-1 col-start-2 row-start-4 lg:col-span-3 lg:col-start-4 lg:row-start-3"
      >
        <StaticImage
          src="../../images/restaurant/April-Bistro-04.jpg"
          width={832}
          sizes="(max-width: 1920px) 44vw, 832px"
          alt={``}
        />
      </Parallax>

      <Parallax
        delta={L3}
        disable={isMobile}
        className="relative col-span-2 col-start-1 row-start-5 lg:-top-1/2 lg:col-span-2 lg:col-start-3 lg:row-start-4"
      >
        <StaticImage
          src="../../images/restaurant/April-Bistro-05.jpg"
          width={905}
          sizes="(max-width: 1024px) 88vw, (max-width: 1920px) 32vw, 548px"
          alt={``}
        />
      </Parallax>

      <Parallax
        delta={L1}
        disable={isMobile}
        className="col-span-1 col-start-1 row-span-3 row-start-6 lg:col-span-3 lg:col-start-1 lg:row-span-5 lg:row-start-5"
      >
        <StaticImage
          src="../../images/restaurant/April-Bistro-06.jpg"
          width={832}
          sizes="(max-width: 1920px) 44vw, 832px"
          alt={``}
        />
      </Parallax>

      <Parallax
        delta={L2}
        disable={isMobile}
        className="col-span-1 col-start-2 row-start-7 lg:col-span-2 lg:col-start-5 lg:row-start-6"
      >
        <StaticImage
          src="../../images/restaurant/April-Bistro-07.jpg"
          width={542}
          sizes="(max-width: 1024px) 44vw, (max-width: 1920px) 30vw, 542px"
          alt={``}
        />
      </Parallax>

      <Parallax
        delta={L2}
        disable={isMobile}
        className="col-start-2 row-span-2 row-start-[8] lg:col-span-2 lg:col-start-5 lg:row-span-1 lg:row-start-[8]"
      >
        <StaticImage
          src="../../images/restaurant/April-Bistro-08.jpg"
          width={542}
          sizes="(max-width: 1024px) 44vw, (max-width: 1920px) 30vw, 542px"
          alt={``}
        />
      </Parallax>
    </div>
  );
}

RestaurantPageAbout.propTypes = {
  teamContent: PropTypes.node,
  viewContent: PropTypes.node,
};

RestaurantPageAbout.defaultProps = {
  teamContent: null,
  viewContent: null,
};

export default RestaurantPageAbout;
